<template>
  <div id="app">
    <AppHeader />
    <main class="app-main">
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<style>
/* 全局样式 */
:root {
  --primary-color: #2c3e50;
  --secondary-color: #42b983;
  --accent-color: #35495e;
  --text-color: #333;
  --light-bg: #f8f9fa;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
}

body {
  font-family: 'Microsoft YaHei', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin: 0;
  color: var(--text-color);
  line-height: 1.6;
  background-color: #fff;
  height: 100%;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-main {
  flex: 1 0 auto; /* 占据剩余空间，但不会收缩 */
  display: flex;
  flex-direction: column;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

a {
  color: var(--primary-color);
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: var(--secondary-color);
}

.btn {
  display: inline-block;
  background: var(--secondary-color);
  color: white;
  padding: 12px 30px;
  border-radius: 4px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.3s ease;
}

.btn:hover {
  background: #3aa876;
  color: white;
}

@media (max-width: 1200px) {
  .container {
    width: 95%;
  }
}

/* 页面切换动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>